import {
    openShippingAddressFormLayerAction, unsetErrorMessageAction,
    closePostcodeLayerAction, closeProductLayerAction, closeOrderStatusLayerAction, closeOrderFormLayerAction
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';

export default function onNoFittingOptionClick() {
    return () => {
        closePostcodeLayerAction();
        closeProductLayerAction();
        closeOrderStatusLayerAction();
        closeOrderFormLayerAction();
        unsetErrorMessageAction();
        openShippingAddressFormLayerAction();
    };
}
